/* eslint-disable */
import { createStyles, makeStyles } from "@material-ui/core";
import type { Theme } from "@material-ui/core";

export const useStyles = makeStyles((theme: Theme) =>
  createStyles({
    root: {
      display: 'flex',
      flexDirection: 'column',
      paddingTop: '24px',
      gap: '6px',
    },
    acceptButton: { 
      height: '46px', 
      background: '#333333',
      color: theme.palette.common.white,
      textTransform: 'capitalize',
      transition: 'opacity: .3s',
      opacity: 1,
      "&:hover": {
        opacity: .7,
        background: '#333333',
        transition: 'opacity: .3s',
      }
    },
    settingsButton: { 
      height: '46px',       
      textTransform: 'capitalize',
      textDecoration: 'underline',
    },
  })
);
